export default {"src":"/_next/static/media/lifebuoy50_40.3edbd7e2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};